(function () {
  'use strict';
  if (window.KaidoPublicSnapshot) return;
  var snapshot = null, anchor = null, floor = -Infinity, flight = null;
  var retryAt = 0, failures = 0, announced = null;
  var VISIBLE_REVALIDATE_MS = 30000, lastCheckAt = -Infinity;
  var SHOP = 'gid://shopify/Shop/71977533629', RAFFLE = '4cb647e0-f520-4aad-a8fd-4cfb420699c4';
  function now() {
    if (!anchor) return NaN;
    floor = Math.max(floor, anchor.time + performance.now() - anchor.mono);
    return floor;
  }
  function date(value) { return typeof value === 'string' ? Date.parse(value) : NaN; }
  function positive(value) { return typeof value === 'number' && Number.isFinite(value) && value > 0 && value <= 1000000; }
  function valid(value, time) {
    return value && value.schema_version === 1 && value.shop_id === SHOP && value.raffle?.id === RAFFLE &&
      Number.isSafeInteger(value.revision) && value.revision > 0 && /^[a-f0-9]{64}$/.test(value.policy_hash) &&
      date(value.generated_at) <= time && date(value.valid_until) > time &&
      time - date(value.generated_at) < 300000 &&
      date(value.raffle.starts_at) < date(value.raffle.ends_at) &&
      ['active', 'upcoming', 'staged', 'cancelled', 'disabled', 'ended'].indexOf(value.raffle.status) !== -1 &&
      Array.isArray(value.windows) && value.windows.length <= 32 &&
      Array.isArray(value.promotions) && value.promotions.length <= 32 &&
      Array.isArray(value.collections) && value.collections.length === 0 &&
      (value.raffle.status !== 'active' || (value.raffle.armed === true && positive(value.base_rate))) &&
      value.windows.every(function (row) { return row && row.raffle_id === RAFFLE && typeof row.enabled === 'boolean' && positive(row.rate) && date(row.starts_at) < date(row.ends_at); }) &&
      value.promotions.every(function (row) { return row && row.raffle_id === RAFFLE && /^[1-9][0-9]*$/.test(row.product_id) && typeof row.enabled === 'boolean' && positive(row.multiplier) && date(row.starts_at) < date(row.ends_at); }) &&
      (!value.daily || (value.daily.state === 'complete' && value.daily.enabled === true && value.daily.raffle_id === RAFFLE &&
        Number.isSafeInteger(value.daily.expected_count) && value.daily.expected_count > 0 &&
        date(value.daily.starts_at) < date(value.daily.ends_at) &&
        date(value.daily.starts_at) >= date(value.raffle.starts_at) && date(value.daily.ends_at) <= date(value.raffle.ends_at) &&
        Array.isArray(value.daily.products) && value.daily.products.length <= 16 && value.daily.products.length === value.daily.expected_count &&
        value.daily.products.every(function (row) { return row && /^[1-9][0-9]*$/.test(row.product_id) && positive(row.multiplier) && date(row.starts_at) < date(row.ends_at) && date(row.starts_at) >= date(value.daily.starts_at) && date(row.ends_at) <= date(value.daily.ends_at); })));
  }
  function get() { var time = now(); return Number.isFinite(time) && valid(snapshot, time) ? snapshot : null; }
  function active() {
    var value = get(), time = now();
    return !!value && value.raffle.status === 'active' && time >= date(value.raffle.starts_at) && time < date(value.raffle.ends_at);
  }
  function rate() {
    if (!active()) return null;
    var time = now(), value = get();
    return Math.max.apply(Math, [value.base_rate].concat(value.windows.filter(function (row) {
      return row.enabled && date(row.starts_at) <= time && time < date(row.ends_at);
    }).map(function (row) { return row.rate; })));
  }
  function notify() {
    var value = get(), key = 'unavailable', time = now();
    if (value) {
      function effective(row) { return row.enabled !== false && date(row.starts_at) <= time && time < date(row.ends_at); }
      // Time boundaries change visible offers even when the published policy is unchanged.
      key = JSON.stringify([value.policy_hash, active(), rate(),
        value.windows.filter(effective), value.promotions.filter(effective),
        value.daily && effective(value.daily) ? value.daily.products.filter(effective) : null]);
    }
    if (key === announced) return;
    announced = key;
    document.dispatchEvent(new CustomEvent('kaido:public-snapshot', { detail: value }));
  }
  async function refresh() {
    if (flight) return flight;
    if (performance.now() < retryAt) return get();
    flight = (async function () {
      var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 8000);
      try {
        var url = new URL(window.Shopify?.routes?.root || '/', location.origin);
        if (url.origin !== location.origin) throw new Error('PUBLIC_ORIGIN');
        url.searchParams.set('section_id', 'kaido-public-snapshot');
        url.searchParams.set('_kaido_clock', crypto.randomUUID());
        var start = performance.now();
        lastCheckAt = start;
        var response = await fetch(url.href, { method: 'GET', credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: controller.signal });
        var sampled = performance.now(), age = Number(response.headers.get('Age') || 0), time = Date.parse(response.headers.get('Date') || '');
        if (!response.ok || !Number.isFinite(time) || !Number.isFinite(age) || age !== 0 || sampled - start > 5000) throw new Error('PUBLIC_CLOCK');
        var body = await response.text();
        if (body.length > 100000) throw new Error('PUBLIC_SIZE');
        var doc = new DOMParser().parseFromString(body, 'text/html');
        var nodes = doc.querySelectorAll('script#kaido-public-snapshot[type="application/json"]');
        if (nodes.length !== 1) throw new Error('PUBLIC_BODY');
        var next = JSON.parse(nodes[0].textContent);
        if (!valid(next, time) || (snapshot && next.revision < snapshot.revision)) throw new Error('PUBLIC_STALE');
        var prior = now(), priorAtSample = Number.isFinite(prior) ? prior - (performance.now() - sampled) : time;
        if (time < priorAtSample - 1000) throw new Error('PUBLIC_CLOCK_REGRESSION');
        anchor = { time: Math.max(time, priorAtSample), mono: sampled };
        snapshot = next; failures = 0; retryAt = performance.now() + 15000; notify();
        return get();
      } catch (_) {
        failures++; retryAt = performance.now() + Math.min(60000, 15000 * failures);
        notify(); return get();
      } finally { clearTimeout(timeout); }
    })();
    try { return await flight; } finally { flight = null; }
  }
  var ready = refresh();
  window.KaidoPublicSnapshot = {
    ready: ready, get: get, now: now, active: active, rate: rate, refresh: refresh,
    product: async function (id) {
      await ready;
      if (!get()) throw new Error('Public offer temporarily unavailable');
      if (!active()) return null;
      var value = get(), time = now(), matches = value.promotions.filter(function (row) {
        return row.product_id === String(id) && row.enabled && date(row.starts_at) <= time && time < date(row.ends_at);
      });
      if (value.daily && date(value.daily.starts_at) <= time && time < date(value.daily.ends_at)) {
        value.daily.products.forEach(function (row) {
          if (row.product_id === String(id) && date(row.starts_at) <= time && time < date(row.ends_at)) matches.push({
            multiplier: row.multiplier, ends_at: row.ends_at, source: 'daily_bonus', promotion_name: row.promotion_name || null,
          });
        });
      }
      if (matches.length > 1) throw new Error('Ambiguous public offer');
      var row = matches[0];
      return row ? { entries_multiplier: row.multiplier, promotion_name: row.promotion_name || null,
        end_date: row.ends_at, source: row.source || 'manual' } : null;
    },
  };
  function needsRefresh(value, time) {
    return !value || date(value.valid_until) - time < 30000 || performance.now() - lastCheckAt >= VISIBLE_REVALIDATE_MS;
  }
  setInterval(function () {
    if (document.hidden) return;
    var value = get(), time = now();
    if (needsRefresh(value, time)) refresh();
    notify();
  }, 1000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && needsRefresh(get(), now())) refresh();
  });
})();
